"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERIES = void 0;

var AttributesList = __importStar(require("./attributes"));

var Collections = __importStar(require("./collections"));

var Orders = __importStar(require("./orders"));

var Product = __importStar(require("./products"));

var Shop = __importStar(require("./shop")); // TODO: Add ability to pass custom fragments to queries


exports.QUERIES = {
  Attributes: function Attributes(client, options) {
    return client.watchQuery(Object.assign({
      query: AttributesList.attributes
    }, options));
  },
  CollectionList: function CollectionList(client, options) {
    return client.watchQuery(Object.assign({
      query: Collections.collections
    }, options));
  },
  GetShopDetails: function GetShopDetails(client, options) {
    return client.watchQuery(Object.assign({
      query: Shop.getShop
    }, options));
  },
  OrderDetails: function OrderDetails(client, options) {
    return client.watchQuery(Object.assign({
      query: Orders.orderDetailsByTokenQuery
    }, options));
  },
  OrderDetailsByUser: function OrderDetailsByUser(client, options) {
    return client.watchQuery(Object.assign({
      query: Orders.userOrderDetailsByTokenQuery
    }, options));
  },
  OrdersByUser: function OrdersByUser(client, options) {
    return client.watchQuery(Object.assign({
      query: Orders.ordersByUser
    }, options));
  },
  VariantsProducts: function VariantsProducts(client, options) {
    return client.watchQuery(Object.assign({
      query: Product.variantsProducts
    }, options));
  }
};